import { render, staticRenderFns } from "./SchoolsPayments.vue?vue&type=template&id=b64d9966&"
import script from "./SchoolsPayments.vue?vue&type=script&lang=js&"
export * from "./SchoolsPayments.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsPayments.vue?vue&type=style&index=0&id=b64d9966&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports